import { isValidNumber } from '../../../utils/validators';
import { getNumberString } from './getNumberString';
import { isNil } from 'ramda';

export const isValidPrice = (value: string) => !isNil(value) && isValidNumber(getNumberString(value));
